import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import { toast } from "react-toastify";
import { getData } from "../../../webService/webservice.js"; // adjust path to your API utility
import Tippy from "tippy.js"; // ✅ tooltip library
import "tippy.js/dist/tippy.css";
function BookingCalendar({ sessionToken }) {
    const role = sessionStorage.getItem("role");
    const adminStoreIds = JSON.parse(sessionStorage.getItem("storeIds") || "[]");
    const [bookings, setBookings] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [selectedStoreId, setSelectedStoreId] = useState(
        sessionStorage.getItem("currentStoreId") || (role === "Admin" ? adminStoreIds[0] || "" : "")
    );
    // ✅ Fetch Bookings
    const fetchBookings = async (params) => {
        try {
            setLoading(true);
            params = {
                storeId: selectedStoreId
            }
            const response = await getData(
                "appointmentbookings/appointmentbookings", params,
                sessionToken
            );
            const resultsWrapper = response?.data?.[0];
            const bookingList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;
            setBookings(bookingList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Booking");
        } finally {
            setLoading(false);
        }
    };

    // ✅ Load bookings when component mounts
    useEffect(() => {
        fetchBookings(selectedStoreId);
    }, [selectedStoreId]);

    // ✅ Convert bookings into FullCalendar events
    const events = bookings.map((booking) => {
        const start = new Date(booking.timeSlot);
        const end = new Date(start);
        end.setHours(end.getHours() + 1); // default 1-hour duration

        const status = booking?.status || "Unknown";
        let backgroundColor = "#3788d8";
        // default black
        if (status === "Completed") backgroundColor = "#28A745"; // green
        if (status === "Pending") backgroundColor = "#FFC107"; // yellow
        if (status === "Cancelled") backgroundColor = "#DC3545"; // red
        if (status === "In Progress") backgroundColor = "#007BFF"
        if (status === "Scheduled") backgroundColor = "#5a6268"


        return {
            id: booking._id,
            title: `${booking.CustomerDetails?.[0]?.name || "Customer"}`,
            start,
            end,
            backgroundColor,
            borderColor: backgroundColor,
            textColor: "#fff",
            extendedProps: {
                status: booking.status,
                store: booking.storeDetails?.[0]?.storeName || "Unknown Store",
                remarks: booking.remarks || "No remarks",
            },
        };
    });

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = sessionStorage.getItem("currentStoreId");
            setSelectedStoreId(storeId);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    return (
        <div className="calender-layout">
            <div className="calender-content">
                <div className="calender-main">
                    <h2>Booking Calendar</h2>
                    <div className="calender-container">
                        <FullCalendar
                            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                            initialView="dayGridMonth"
                            displayEventTime={false}
                            headerToolbar={{
                                left: "prev,next today",
                                center: "title",
                                right: "dayGridMonth,timeGridWeek,timeGridDay",
                            }}
                            events={events} // ✅ pass mapped bookings
                            height="auto"
                            eventDidMount={(info) => {
                                const { status, store, remarks } = info.event.extendedProps;
                                const startTime = new Date(info.event.start).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                });
                                const endTime = new Date(info.event.end).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                });

                                let themeClass = "tooltip-default";
                                if (status === "Completed") themeClass = "tooptip-completed";
                                if (status === "Pending") themeClass = "tooltip-pending";
                                if (status === "Cancelled") themeClass = "tooltip-cancelled";
                                if (status === "In Progress") themeClass = "tooltip-inProgress";
                                if (status === "Scheduled") themeClass = "Scheduled";

                                Tippy(info.el, {
                                    content: `
                    <strong>Customer:</strong> ${info.event.title} <br/>
                    <strong>Time:</strong> ${startTime} - ${endTime} <br/>
                    <strong>Status:</strong> ${status} <br/>
                    <strong>Store:</strong> ${store} <br/>
                    <strong>Remarks:</strong> ${remarks}
                  `,
                                    allowHTML: true,
                                    theme: "light", // use base light the
                                    onShow(instance) {
                                        instance.popper.classList.add(themeClass);
                                    },
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BookingCalendar;
